import { withErrorBoundary } from "@edreamsodigeo/frontend-core";

import withPrimeContext from "../withPrimeContext";
import { EqualProminenceMobile } from "~/components/engage/EqualProminenceMobile";

export default withPrimeContext(
  withErrorBoundary(EqualProminenceMobile, {
    name: "PrimeEqualProminenceMobile",
  }),
);
